export function setUser(email, ...props) {
  window.bugsnagClient.user = {
    email,
    ...props,
  };
}
